import type { SVGProps } from "react";
import { BUBBLE_LOADER_DEFAULTS } from "./BubbleLoader/config";
import { bubbleGroups, connectorPath } from "./BubbleLoader/geometry";

const groups = bubbleGroups().map((group) => ({
  ...group,
  paths: group.edges.map(([i, j]) =>
    connectorPath(
      group.points[i],
      group.points[j],
      BUBBLE_LOADER_DEFAULTS.neckWidth,
    ),
  ),
}));

export function Icon({
  colors = BUBBLE_LOADER_DEFAULTS.colors,
  ...props
}: SVGProps<SVGSVGElement> & { colors?: readonly string[] }) {
  return (
    <svg viewBox="-6.2 -3.4 12.4 6.8" role="img" aria-label="Bubble" {...props}>
      <g transform="scale(1 -1)">
        {groups.map((group) => (
          <g key={group.colorIndex} fill={colors[group.colorIndex]}>
            {group.paths.map((path, index) => (
              <path key={index} d={path} />
            ))}
            {group.points.map(([x, y], index) => (
              <circle key={index} cx={x} cy={y} r={1} />
            ))}
          </g>
        ))}
      </g>
    </svg>
  );
}
